module.exports = __webpack_public_path__ + "img/2022-7.e3cc78f0.jpg";